import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { CommissionDefaultProps } from 'src/containers/commission-container/CommissionPropTypes';
import { cloneDeep } from 'lodash-es';
import { COMMISSION_ACTIONS } from '../actions/CommissionActions';

const initialState = () => ({
    currentRecord: cloneDeep(CommissionDefaultProps),
    currentRecordPopulated: cloneDeep(CommissionDefaultProps),

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case COMMISSION_ACTIONS.COMMISSION_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case COMMISSION_ACTIONS.COMMISSION_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case COMMISSION_ACTIONS.COMMISSION_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case COMMISSION_ACTIONS.COMMISSION_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case COMMISSION_ACTIONS.COMMISSION_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case COMMISSION_ACTIONS.COMMISSION_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        case COMMISSION_ACTIONS.COMMISSION_POPULATED_RECORD_UPDATE: {
            return {
                ...state,
                currentRecordPopulated: action.data,
            };
        }

        // RESET
        case COMMISSION_ACTIONS.COMMISSION_RESET: {
            return initialState();
        }
        default:
            return state;
    }
};
